import {ExpenseApprovalStatus, ExpenseReimbursementStatus, ExpenseSystemType} from "../@types";
import {ExpenseCategoryAccessControl} from "./access-control/access-control";
import ModelEntity from "../../model-entity";
import ErrorFieldRequired from "../../../gd/validation/error-field-required";

const debug = false
// const debug = "ExpenseCategory"

export default class ExpenseCategory extends ModelEntity {

    // public id                    : ID
    public systemType            : ExpenseSystemType

    public approvalStatus       : ExpenseApprovalStatus
    public reimbursement         : ExpenseReimbursementStatus

    public name                  : string
    public isDeleted             : boolean
    public sortPosition          : number

    public unitName?             : string
    public unitPrice?            : number

    constructor(expenseCategoryConfig:any) {
        super(expenseCategoryConfig);

        this.id                     = expenseCategoryConfig.id
        this.name                   = expenseCategoryConfig.name
        this.systemType             = _.get(expenseCategoryConfig, 'systemType', ExpenseSystemType.AMOUNT)
        this.approvalStatus         = _.get(expenseCategoryConfig, 'approvalStatus') || ExpenseApprovalStatus.PENDING
        this.isDeleted              = _.get(expenseCategoryConfig, 'isDeleted', false)
        this.sortPosition           = _.get(expenseCategoryConfig, 'sortPosition', 0)
        this.reimbursement          = _.get(expenseCategoryConfig, 'reimbursement') || ExpenseReimbursementStatus.NOT_REIMBURSABLE

        // unit related
        this.unitName               = _.get(expenseCategoryConfig, 'unitName', undefined)
        this.unitPrice              = _.get(expenseCategoryConfig, 'unitPrice', undefined)

        return this
    }

    get acl():ExpenseCategoryAccessControl {
        return new ExpenseCategoryAccessControl(this)
    }

    get isAmountBased():boolean {
        return this.systemType === ExpenseSystemType.AMOUNT
    }

    get isUnitBased():boolean {
        return this.systemType === ExpenseSystemType.UNIT
    }

    validate() {


        const errors : any[] = []

        if (!this.name) errors.push(new ErrorFieldRequired(gd.fields.expenseCategory.name))
        if (_.isNil(this.approvalStatus)) errors.push(new ErrorFieldRequired(gd.fields.expenseCategory.approvalStatus))
        if (_.isNil(this.reimbursement)) errors.push(new ErrorFieldRequired(gd.fields.expenseCategory.reimbursement))

        switch (this.systemType) {

            case ExpenseSystemType.UNIT:
                if (!this.unitName) errors.push(new ErrorFieldRequired(gd.fields.expenseCategory.unitName))
                if (!this.unitPrice) errors.push(new ErrorFieldRequired(gd.fields.expenseCategory.unitPrice))
                break

            case ExpenseSystemType.AMOUNT:
            default:

                break
        }

        if (_.isEmpty(errors)) return null

        return errors

    }

    toOption():Option {
        return {
            label       : this.name,
            value       : this.id
        }
    }

    toJSON() {
        return {
            id                   : this.id,
            systemType           : this.systemType,
            approvalStatus       : this.approvalStatus,
            reimbursement        : this.reimbursement,
            name                 : this.name,
            isDeleted            : this.isDeleted,
            sortPosition         : this.sortPosition,
        }
    }
}
